import script from "./DeveloperWhiteListProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./DeveloperWhiteListProduct.vue?vue&type=script&setup=true&lang=js"

import "./DeveloperWhiteListProduct.vue?vue&type=style&index=0&id=02437bfd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02437bfd"]])

export default __exports__